import { Flex } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { useKeyPresses } from '~/hooks/useKeyboard'
import { TCallAnalyticsTab } from '~/pages/Calls/CallDetails/CallDetailsAnalyticsContent'
import { CallDetailsContent } from '~/pages/Calls/CallDetails/CallDetailsContent'
import { ZIndex } from '~/types/ThemeTypes'
import { hasValue } from '~/utils/common'

import { CallInstance } from '@mangovoice/types'

const PANEL_ANIMATION_TIME_SECONDS = 0.3

interface CallDetailsPanelProps {
  callId?: number
  callInstance?: CallInstance
  callInstanceLoading: boolean
  onClosed?: () => void
  onOpenModal?: () => void
  initialTab?: TCallAnalyticsTab
  onVoicemailClick?: () => void
}
export const CallDetailsPanel = ({
  callId,
  callInstance,
  callInstanceLoading,
  onClosed,
  onOpenModal,
  initialTab,
  onVoicemailClick,
}: CallDetailsPanelProps) => {
  const [isClosing, setIsClosing] = useState<boolean>(true)

  const handleWillOpen = () => {
    setIsClosing(false)
  }

  const handleWillClose = () => {
    setIsClosing(true)
  }

  //sets up open/close animations cleanly
  const shouldBeClosed = !hasValue(callId)
  useEffect(() => {
    if (!shouldBeClosed) {
      handleWillOpen()
      return
    }

    handleWillClose()
  }, [callId])

  const wrapperWidthValue = isClosing ? '0rem' : '37.5rem'

  useKeyPresses({
    filter: (e) => e.key === 'Escape',
    onPress: (_) => {
      onClosed?.()
    },
  })

  return (
    <>
      <Flex
        position={'inherit'}
        right="0rem"
        width={wrapperWidthValue}
        height="full"
        transition={`width, ${PANEL_ANIMATION_TIME_SECONDS}s`}
        tabIndex={shouldBeClosed ? -1 : 0}
        zIndex={ZIndex.overlay}
        borderLeft="2px solid"
        borderLeftColor="gray.400"
      >
        <CallDetailsContent
          callId={callId}
          callInstance={callInstance}
          callInstanceLoading={callInstanceLoading}
          onClosed={onClosed}
          isModal={false}
          onOpenModal={onOpenModal}
          initialTab={initialTab}
          onVoicemailClick={onVoicemailClick}
        />
      </Flex>
    </>
  )
}
